import React, { memo } from 'react';
import './Input.scss';
import classnames from 'classnames';

interface Props {
    id?: string,
    label?: string,
    value?: string | number,
    type?: string,
    name?: string,
    placeholder?: string,
    onInputChange?: ((event: React.ChangeEvent<HTMLInputElement>) => void) | undefined,
}

const Input: React.FC<Props> = ({
  id = String(Date.now()), label = 'Input label', placeholder = 'Enter text here', value = '', name = '', type = 'text', onInputChange = () => {},
}): JSX.Element => {
  const classes = classnames({
    'nw-input': true,
  });
  return (
    <div className={classes}>
      <span>{label}</span>
      <input
        id={id}
        name={name}
        type={type}
        value={value}
        placeholder={placeholder}
        onChange={onInputChange}
      />
    </div>
  );
};

export default memo(Input);
